<!-- Button -->
<div
  class="felx-row flex cursor-pointer items-center gap-2 rounded-md p-2"
  matRipple
  [matRippleDisabled]="false"
  [matRippleUnbounded]="false"
  [matMenuTriggerFor]="userActions"
>
  <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
  <div class="text-lg font-semibold">{{ user?.name }}</div>
</div>

<mat-menu [xPosition]="'before'" #userActions="matMenu" class="vertical-layout-menu">
  <span class="text-primary dark:text-on-surface flex flex-col p-3 leading-none">
    <span>Signed in as</span>
    <span class="text-md mt-1.5 font-medium">{{ user?.email }}</span>
  </span>
  <button mat-menu-item (click)="signOut()">
    <mat-icon>logout</mat-icon>
    <span>Logout</span>
  </button>
</mat-menu>
